export function parseReceiverName(text: string, receiverName: string) {
  return text.includes('{receiverName}')
    ? text.replaceAll('{receiverName}', receiverName || '')
    : text
}
